import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Table } from 'semantic-ui-react';
import styles from '../../Form.scss';
import Checkboxes from '../Widgets/Checkboxes';
import TextList from '../Widgets/TextList';
import TableComponent from '../Widgets/Table';
import { RootConsumer } from '../../../../RootComponent';

const COMPONENT_TYPES = {
  checkboxes: Checkboxes,
  textList: TextList,
  table: TableComponent
};

export default class ArrayField extends React.Component {

  static propTypes = {
    formData: PropTypes.array,
    onChange: PropTypes.func.isRequired,
    schema: PropTypes.object.isRequired,
    uiSchema: PropTypes.object,
    value: PropTypes.string
  }

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.addResponse = this.addResponse.bind(this);
    this.removeResponse = this.removeResponse.bind(this);
  }

  onChange(value, index) {
    const formData = this.props.formData ? this.props.formData.slice() : [];
    formData[index] = value;
    this.props.onChange(formData);
  }

  addResponse() {
    const formData = this.props.formData ? this.props.formData.slice() : [];
    switch (this.props.uiSchema['ui:widget']) {
      case 'textList':
        formData.push('');
        break;
      case 'table':
        formData.push({});
        break;
      default:
        formData.push('');
    }
    this.props.onChange(formData);
  }

  removeResponse(index) {
    const formData = this.props.formData.slice();
    formData.splice(index, 1);
    this.props.onChange(formData);
  }

  render() {
    const { schema, uiSchema, onChange } = this.props;
    const formData = this.props.formData || (uiSchema && uiSchema['ui:widget'] === 'textList' ? [''] : []);
    const widgetName = uiSchema && uiSchema['ui:widget'] || 'textList';
    const Widget = COMPONENT_TYPES[widgetName];
    const addText = `Add ${uiSchema && uiSchema['ui:widget'] === 'table' ? 'Row' : 'Another'}`;
    return (
      <RootConsumer>
        {({ isComputer }) =>
          <div>
            {widgetName === 'checkboxes' &&
              <Widget
                schema={schema}
                onChange={onChange}
                uiSchema={uiSchema}
                formData={formData}
              />}
            {widgetName === 'table' &&
              <Table stackable>
                {isComputer &&
                  <Table.Header>
                    <Table.Row>
                      {uiSchema['ui:headers'].map((header, index) =>
                        <Table.HeaderCell key={index}>
                          {schema.items.properties[header].title}
                        </Table.HeaderCell>
                      )}
                      <Table.HeaderCell />
                    </Table.Row>
                  </Table.Header>}
                <Table.Body>
                  {formData.map((item, index) => (
                    <Widget
                      schema={schema}
                      onChange={onChange}
                      uiSchema={uiSchema}
                      formData={item}
                      key={index}
                      onChange={(e) => this.onChange(e, index)}
                      removeResponse={() => this.removeResponse(index)}
                    />
                  ))}
                </Table.Body>
              </Table>
            }
            {widgetName !== 'table' && widgetName !== 'checkboxes' && formData.map((item, index) => (
              <div style={{ display: 'flex' }} key={index} className={styles.responseField}>
                <div style={{ flex: 1 }}>
                  <Widget
                    schema={schema}
                    onChange={onChange}
                    uiSchema={uiSchema}
                    formData={item}
                    key={index}
                    onChange={(e) => this.onChange(e, index)}
                  />
                </div>
                {index > 0 &&
                  <span
                    className={styles.deleteItemRelative}
                    style={{ marginTop: '0.5em' }}
                    onClick={() => this.removeResponse(index)}
                  >
                    <Icon name='close' />
                  </span>
                }
                {index === 0 && <span style={{ width: '1.5em' }}></span>}
              </div>
            ))}
            {widgetName !== 'checkboxes' && <a onClick={this.addResponse}>+ {addText}</a>}
          </div>}
      </RootConsumer>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Renderer/Fields/Array.js